import type { TiebreakerTeam, TiebreakerStepFn, StepResult } from '../types';
import { RankMethod } from '../../enums/rank-method';
import { addExplanation } from '../helpers';

/**
 * Terminal coin flip step.
 * Always resolves by picking one winner via ctx.coinFlipFn.
 */
export const coinFlipStep: TiebreakerStepFn<TiebreakerTeam> = (teams, ctx) => {
  const winner = ctx.coinFlipFn(teams);
  const remaining = teams.filter(t => t !== winner);
  addExplanation(ctx, winner, 'Coin flip.');
  return { winners: [winner], remaining, rankMethod: RankMethod.CoinFlip };
};
